export const dealersAddressSubMenu = [{
  path: '/dealers-addresses/list/:dealerId(\\d+)',
  component: () => import('@/views/dealers-addresses/list.vue'),
  name: 'dealerManagement.address.title',
  meta: {
    title: 'dealerManagement.address.title',
    icon: 'user',
    noCache: true,
    hidden: true
  }
}, {
  path: '/dealers-addresses/add/:dealerId(\\d+)',
  component: () => import('@/views/dealers-addresses/manage.vue'),
  name: 'dealerManagement.address.add',
  props: {
    isEdit: false
  },
  meta: {
    roles: ['Super Admin', 'Admin'],
    title: 'dealerManagement.address.add',
    noCache: true,
    activeMenu: '/dealers-addresses/list/:dealerId(\\d+)',
    hidden: true
  }
}, {
  path: '/dealers-addresses/edit/:id(\\d+)',
  component: () => import('@/views/dealers-addresses/manage.vue'),
  name: 'dealerManagement.address.edit',
  props: {
    isEdit: true
  },
  meta: {
    roles: ['Super Admin', 'Admin'],
    title: 'dealerManagement.address.edit',
    noCache: true,
    activeMenu: '/dealers-addresses/list/:dealerId(\\d+)',
    hidden: true
  }
}];